import { Box } from "@chakra-ui/layout";
import useTranslationConstants from "lib/utils/constants";
import React from "react";
import Slider from "react-slick";

const ImageSlider = ({ color }: { color: string }) => {
  const { LINKS } = useTranslationConstants();
  const settings = {
    // eslint-disable-next-line i18next/no-literal-string
    className: "register-slider",
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    style: { maxWidth: "100%", height: "100%" },
  };

  const slides = [
    LINKS.images.registerSlider.running,
    LINKS.images.registerSlider.swimming,
    LINKS.images.registerSlider.running2,
    LINKS.images.registerSlider.ridingABike,
  ];

  return (
    <Slider {...settings}>
      {slides.map((slide, i) => (
        <Box
          key={i}
          w="full"
          h="full"
          pos="relative"
          background={`url(${slide})`}
          backgroundPosition="center center"
          backgroundSize="cover"
          zIndex="5"
        >
          <Box
            inset="0"
            pos="absolute"
            zIndex="10"
            bg={color}
            opacity="0.8"
          />
        </Box>
      ))}
    </Slider>
  );
};

export default ImageSlider;
